/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-21 10:59:36
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-31 16:53:18
 */
import React from 'react'
import { Avatar, Input, message, Skeleton } from 'antd'
import axios from 'axios'
import { ChangeRoom, DeleteTalkList, AddUserCache, DeleteFriend, ChangeActiveRoomName, AddTalkList } from '../../../../store/actionCreators'
import { connect } from 'react-redux'
import { gettalkListonline, getuserinfo } from '../../../../service/loginaction'
import Search from 'antd/lib/input/Search'


// *******   *********   ***************   **   ***********   ********
// ********  **********            ****   ***   **********   *********
// ***            ******  *******  ****              **            ***
// ***  ********  ***   *********  ****   *************   ******   ***
// ***  ********  ***           *  ***              ***            ***
// ***            ***      **   *  **     ********  ***   ******   ***
// ***  ***   *******      **   *  **     *************            ***
// ***             **           *  **               ***   ******   ***
// **   **  *********      **   *  ****   *************            ***
// **   **  *********      **   *  ****             ********  ***  ***
// **   *         ***           *  ****      ****  ***         **   **
// **   *   ***   ***   *********  ****      ****  ***      *  ***   *
// *   *   ****   ***   *********  ****            ***  *   ***      *
// *      ***     ***   *******    ****      ****   *   *         ****
// ***   **********************  ******   ****************************

class ChatInfo extends React.PureComponent {
    state = {
        // avatar: '',
        userlist: [],
        searchtext: '',
        frienduser: {},
        isOwner: false
    }
    componentDidMount() {
        //解决redux组件ref 不到的问题
        this.props.onRef(this)
        // debugger
    }
    load = (room) => {
        // const activeRoom = this.props.activeRoom
        if (room.type === 'public') {
            axios.get(`${global.serviceUrl.chat}/group/${room.roomId.substring(7)}/member/info`).then((data) => {
                let memberlist = data.data.payload
                let userlist = []
                memberlist.forEach(memberinfo => {
                    if (memberinfo.groupRole === 'owner') {//找出 群主
                        if (this.props.user.userId == memberinfo.userId) {//群主 是本机没错了
                            this.setState({ isOwner: true })
                        } else {
                            this.setState({ isOwner: false })
                        }
                    }
                    let user = memberinfo.account
                    userlist.push(user)
                    user = getuserinfo(user.userId)
                    // this.AddUserCache(user)
                });
                this.setState({ userlist: userlist }, () => {
                    this.props.getGroupmumberList(this.state.userlist)
                })

            }).catch((e) => {
            })
        }
        else if (room.type === 'private') {
            let frienduser = getuserinfo(room.roomId.substring(9), (frienduser) => {

                this.setState({ frienduser: frienduser || {} })
            })
            this.setState({ frienduser: frienduser || {} })

        }
    }
    searchfriend = ({ target: { value } }) => {
        this.setState({ searchtext: value })
    }

    // 修改群名
    changeRoomName = async (event) => {
        // debugger
        event.persist()
        let roomInfo
        const { data: getRes } = await axios.get(`${window.serviceUrl.chat}/group/${this.props.activeRoom.receiverId}`)
        if (getRes.code === '200') {
            roomInfo = getRes.payload
            roomInfo.groupName = event.target.value
        }

        const { data: postRes } = await axios.post(`${window.serviceUrl.chat}/group/save`, roomInfo)
        // console.log(postRes)
        if (postRes.code === '200') {
            // 更改群房间名
            const groupInfo = {
                chatName: event.target.value,
                receiverId: this.props.activeRoom.receiverId,
                lastMsg: this.props.activeRoom.lastMsg,
                unReadMsg: this.props.activeRoom.unReadMsg,
                serial: this.props.activeRoom.serial,
                roomId: this.props.activeRoom.roomId,
                lastMsgTime: this.props.activeRoom.lastMsgTime,
                avatar: this.props.activeRoom.avatar,
                type: this.props.activeRoom.type,
            }
            this.props.ChangeActiveRoomName(groupInfo)
            // 更改消息列表中的群名
            let beChangedGroup = this.props.talkList.filter((item) => {
                return item.roomId === this.props.activeRoom.roomId
            })
            beChangedGroup[0].chatName = event.target.value
            let _talkList = this.props.talkList
            _talkList.map((item) => {
                return item.roomId === beChangedGroup[0].roomId ? beChangedGroup[0] : item
            })
            // this.props.AddTalkList([])
            _talkList.forEach(element => {
                this.props.AddTalkList(element)
            })
            // this.props.AddTalkList({data:_talkList})
            // this.props.AddTalkList(_talkList)
            // console.log(_talkList)

            // this.props.ChangeRoom({ roomInfo: groupInfo })

            // this.load(this.props.activeRoom)
        }
    }

    /**
     * 删除会话
     */
    delChat = () => {
        axios.delete(`${global.serviceUrl.chat}/contact/del?serial=${this.props.activeRoom.serial}`).then((data) => {
            data = data.data
            if (data.code === '200') {
                // message.success('删除会话成功！')
                this.props.close()
                this.props.ChangeRoom({ roomInfo: null })
                this.props.DeleteTalkList({ serial: this.props.activeRoom.serial })
            }
        }).catch((e) => {

        })
    }
    /**
     * 退出 /解散  群聊
     */
    leavegroup = async () => {
        // debugger
        if (!this.state.isOwner) {
            axios.delete(`${global.serviceUrl.chat}/group/${this.props.activeRoom.receiverId}/member/del?memberId=${this.props.user.userId}`, {
            }).then((data) => {
                // debugger
                data = data.data
                if (data.code === '200') {
                    message.success('退出群聊成功！')
                    this.delChat()
                }
            }).catch((e) => {

            })
        } else {
            // message.info('缺少解散接口')
            //    debugger
            const { data: res } = await axios.delete(`${global.serviceUrl.chat}/group/del?groupId=${this.props.activeRoom.receiverId}`)
            if (res.code === '200') {
                message.success('成功解散群！')
                this.delChat()
            }

        }
    }
    deletefriend = () => {
        axios.delete(`${global.serviceUrl.chat}/friend/del`, {
            params: {
                user1: this.props.user.userId,
                user2: this.state.frienduser.userId
            }
        }).then((data) => {
            data = data.data
            if (data.code === '200') {
                message.success('删除好友成功！')
                this.props.DeleteFriend({ userId: this.state.frienduser.userId })
            }
        }).catch((e) => {

        })
    }
    openAddGroupMumberPanel = () => {
        this.props.showAddGroupMumberPanel()
    }
    render() {
        const privateroom = <div className='chatview-chatinfo-panel-private'>
            <div className={'chatview-chatinfo-private-namepanel'}  >
                <Avatar className={'chatview-chatinfo-private-avatar'} src={this.state.frienduser.avatar}></Avatar>
                {this.state.frienduser.userName}
            </div>
            <div className={'chatview-chatinfo-private-attributepanel'}  >
                <div>
                    {'电话：'} {this.state.frienduser.phone}
                </div>
                <div>
                    {/* {'账号消息等内容'} */}<Skeleton.Input style={{ paddingTop: 5, width: 160, height: 20 }}></Skeleton.Input>
                </div>
                <div>
                    {/* {'账号消息等内容'} */}<Skeleton.Input style={{ paddingTop: 5, width: 160, height: 20 }}></Skeleton.Input>
                </div>
            </div>
            <div className={'chatview-chatinfo-private-delete'} onClick={this.deletefriend} >
                {'删除好友'}
            </div>
        </div>
        const publicroom = <div className='chatview-chatinfo-panel-public'>
            <div className='chatview-chatinfo-public-title'>
                {'群组名称'}
            </div>
            <Input
                key={this.props.activeRoom.roomId}
                onBlur={(event) => this.changeRoomName(event)}
                defaultValue={
                    // this.props.activeRoom.chatName
                    this.props.activeRoom.type === 'public' ?
                        this.props.newGroupList.find((item) => {
                            return item.roomId === this.props.activeRoom.roomId
                        }).chatName : this.props.activeRoom.chatName
                }
                allowClear
                className='chatview-chatinfo-public-chatname'>

            </Input>
            <div className='chatview-chatinfo-public-title'>
                {'群成员'}
            </div>
            <div className='chatview-chatinfo-public-searchbox-panel'>
                {/* <Input className='chatview-chatinfo-public-searchbox'
                    placeholder={'查找成员'} onChange={this.searchfriend.bind(this)}
                    prefix={<img src={require('../../../resources/img/icon-search.png')} />} ></Input> */}
                <Search className='common-search' onChange={this.searchfriend} placeholder='搜索'></Search>

            </div>
            <div style={{ height: 40 }}>
                <div className='chatview-chatinfo-public-count'>
                    {'共 ' + this.state.userlist.length + ' 人'}
                </div>
                <div className='chatview-chatinfo-public-addnew' onClick={this.openAddGroupMumberPanel}>
                    {'添加成员'}
                </div>
            </div>
            <div className='chatview-chatinfo-public-divider'> </div>
            <div className='chatview-chatinfo-public-listscroller'>
                {this.state.userlist.map((user) => {
                    return (
                        // <div key={user.userId} style={{ display: user.userName.indexOf(this.state.searchtext) != -1 ? 'block' : 'none' }}>
                        <div key={user.userId} style={{ display: user.userId && user.userId.includes(this.state.searchtext) ? 'block' : 'none',width:'100%'}}>
                            <div className='chatview-chatinfo-memberlist-entity'>
                                <Avatar src={ global.yunguanAvatar + user.avatar} className={'chatview-chatinfo-memberlist-avatar'} ></Avatar>
                                <div className='chatview-chatinfo-memberlist-text'>
                                    {user.userId}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className={'chatview-chatinfo-private-delete'} onClick={this.leavegroup}>
                {this.state.isOwner ? '解散该群' : '退出该群'}
            </div>
        </div>
        return (
            <>
                {
                    this.props.activeRoom.type === 'private' ? privateroom : publicroom
                }
            </>
        )
    }
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    activeRoom: state.userReducer.get('activeRoom'),
    talkList: state.userReducer.get('talkList').toJS(),
    newGroupList: state.userReducer.get('newGroupList').toJS()

})

const mapDispatch = dispatch => ({
    ChangeRoom(param) {
        dispatch(ChangeRoom(param))
    },
    DeleteTalkList(param) {
        dispatch(DeleteTalkList(param))
    },
    AddUserCache(param) {
        dispatch(AddUserCache(param))
    }, DeleteFriend(param) {
        dispatch(DeleteFriend(param))
    },
    ChangeActiveRoomName(param) {
        dispatch(ChangeActiveRoomName(param))
    },
    AddTalkList(param) {
        dispatch(AddTalkList(param))
    }
})

export default connect(
    mapState,
    mapDispatch
)(ChatInfo)
